export default __webpack_public_path__ + "static/media/myAppsTitleIcon.c7e1917a.svg";